module.exports = __webpack_public_path__ + "static/tickr-fac3e9aad92f186c7a34a8b855aacc0a.jpg";